import { Button } from "@sede-enterprise/shell-ds-react-framework";
import dayjs from "dayjs";
import { toPng } from "html-to-image";
import { PDFDocument } from "pdf-lib";
import type React from "react";
import type { ICalculatorFormState } from "../../../types/types";

const DownloadPdf = (props: {
  state: ICalculatorFormState;
  setIsHideAllButtons: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  const { state, setIsHideAllButtons } = props;

  const handleDownloadPdf = async (target: string) => {
    let domElement: HTMLElement = document.getElementById("my-node")!;

    if (target === "step3") {
      const elements = document.getElementsByClassName("step3");
      if (elements.length > 0) {
        domElement = elements[0] as HTMLElement;
      }
    }

    // Hide download buttons while generating
    setIsHideAllButtons(true);

    try {
      // 1) Render DOM -> PNG (base64 data URL)
      const dataUrl = await toPng(domElement);

      // 2) Create pdf-lib document & A4 page (points)
      const pdfDoc = await PDFDocument.create();
      const page = pdfDoc.addPage([595, 842]); // A4 portrait

      // 3) Embed PNG (pass only base64 payload)
      const base64Data = dataUrl.split(",")[1];
      const pngImage = await pdfDoc.embedPng(base64Data);

      // 4) SCALE THE IMAGE TO FIT THE PAGE WIDTH (preserve aspect ratio)
      const imgW = pngImage.width;
      const imgH = pngImage.height;

      const pageW = page.getWidth();
      const pageH = page.getHeight();

      // Optionally use margins (uncomment to apply)
      // const margin = 16; // in PDF points
      // const availableW = pageW - margin * 2;
      // const scale = availableW / imgW;
      // const scaledW = imgW * scale;
      // const scaledH = imgH * scale;
      // const xPos = margin;
      // const yPos = (pageH - scaledH) / 2;

      // Current logic: fit to page width
      const scaleToWidth = pageW / imgW;
      const scaledW = imgW * scaleToWidth;
      const scaledH = imgH * scaleToWidth;
      const xPos = 0;
      const yPos = (pageH - scaledH) / 2; // center vertically; set 0 to top-align

      // 5) Draw the image
      page.drawImage(pngImage, {
        x: xPos,
        y: yPos,
        width: scaledW,
        height: scaledH,
      });

      // 6) Build filename
      const timestamp = dayjs().format("DDMMMYYYY_HH-mm-ss");
      const downloadAs =
        target === "step3"
          ? `${state.opportunity}_KPI_Data_${timestamp}.pdf`
          : `${state.opportunity}_${timestamp}.pdf`;

      // 7) Save and create Blob (ensure proper ArrayBuffer for TS DOM types)
      const pdfBytes = await pdfDoc.save(); // Uint8Array
      const ab = (pdfBytes.buffer as ArrayBuffer).slice(0, pdfBytes.byteLength);
      const blob = new Blob([ab], { type: "application/pdf" });

      // 8) Trigger download & cleanup
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = downloadAs;
      document.body.appendChild(link);
      link.click();

      // Revoke blob URL and remove anchor on next tick so the click resolves
      setTimeout(() => {
        URL.revokeObjectURL(url);
        link.remove();
      }, 0);

      // Re-show buttons
      setIsHideAllButtons(false);
    } catch {
      // Optionally log or toast error here
      setIsHideAllButtons(false);
    }
  };

  return (
    <>
      <Button
        variant="outlined"
        hidden={state.isHideAllButtons}
        className="align-btns-right btn-size download-step3"
        onClick={() => handleDownloadPdf("step3")}
      >
        Download Step 03
      </Button>

      <Button
        variant="filled"
        hidden={state.isHideAllButtons}
        className="align-btns-right btn-size"
        onClick={() => handleDownloadPdf("fullPage")}
      >
        Download Deal
      </Button>
    </>
  );
};

export default DownloadPdf;
